import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { slugRedirectGuard } from './guards/slug-redirect.guard';
import { userGuard } from './guards/user.guard';
import { TemplistComponent } from './templist/templist.component';
import { mainFeedResolver } from './resolver/main-feed.resolver';
import { editFeedResolver } from './resolver/edit-feed.resolver';
import { featureflagResolver } from './resolver/feature-flag.resolver';

export const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard, slugRedirectGuard],
        resolve: { featureFlags: featureflagResolver },
        children: [
            {
                path: ':account/:brand',
                canActivate: [userGuard],
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./views/stepper/stepper.component').then(m => m.StepperComponent),
                        title: 'Create a new feed'
                    },
                    { path: 'list', component: TemplistComponent },
                    {
                        path: 'feed-editor/:id',
                        title: 'Overview your feed',
                        children: [
                            {
                                path: '',
                                loadComponent: () =>
                                    import('./views/feed-overview/feed-overview.component').then(
                                        m => m.FeedOverviewComponent
                                    ),
                                resolve: { mainFeed: mainFeedResolver }
                            },
                            {
                                path: 'edit',
                                loadComponent: () =>
                                    import('./views/feed-edit/feed-edit.component').then(m => m.FeedEditComponent),
                                title: 'Edit your feed',
                                resolve: {
                                    mainFeed: editFeedResolver
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
